<svg
    id="svg_c1"
    width="1024"
    height="600"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    xmlns:xhtml="http://www.w3.org/1999/xhtml"
   
    
>
<style>
    .align-center {
        text-align: center;
    }

    .text-32 {
        font-size: 32px;
    }

    .text-45 {
        font-size: 45px;
    }

 

    .brand-info p, .brand-info span {
        font-family: "Roboto";
        color: white;
        line-height: 1.1;
    }

 
    #svg-tag1Line {
        max-height: 40px;
    }

    #svg-tag2Line {
        max-height: 30px;
    }

    #svg-contactLine1{
        margin-bottom:0px;
        padding-bottom:0px
    }
    #svg-contactLine1Overflow{
        display:inline-block
    } 
    #svg-contactLine2{
        margin-bottom:0px;
        padding-bottom:0px
    }
    #svg-contactLine2Overflow{
        display:inline-block
    } 
        #svg-contactLine3{
        margin-bottom:0px;
        padding-bottom:0px
    }-->
    #svg-contactLine3Overflow{
        display:inline-block
    } 

</style>
    <rect width="1024" height="600" />
    <!-- inner rectangle with border -->
    <rect width="948" height="528" x="38" y="36" rx="8" ry="8" fill="#1f1f1f" stroke="#383838" stroke-width="3" />
    <!-- shield image -->
    <path
        transform="translate(322, 100)"
        opacity="0.1"
        d="M257.655 359.887C292.114 333.547 337.83 288.743 359.706 224.777C374.642 180.044 381.431 132.993 379.749 85.8601C379.288 71.1579 377.991 56.494 375.864 41.9393C375.718 40.948 375.376 39.9957 374.857 39.1384C374.339 38.2811 373.654 37.5359 372.845 36.9465C372.029 36.3495 371.102 35.921 370.119 35.6863C369.135 35.4516 368.116 35.4152 367.118 35.5794C353.12 37.7931 338.969 38.9043 324.797 38.9026C278.401 39.5431 232.89 26.1767 194.202 0.547502C192.821 0.0658392 191.35 -0.101103 189.896 0.0589183C188.443 0.218939 187.043 0.701935 185.8 1.47247C147.032 27.0705 101.47 40.422 55.0248 39.7948C40.9126 39.79 26.8225 38.6789 12.8838 36.4717C11.8863 36.3102 10.8667 36.348 9.88381 36.5826C8.90093 36.8172 7.97414 37.2439 7.15694 37.8385C6.34793 38.427 5.66444 39.171 5.14611 40.0269C4.62778 40.8828 4.28484 41.8334 4.13795 42.8233C2.00955 57.3531 0.712295 71.9926 0.25212 86.6704C-1.43539 133.794 5.35912 180.837 20.3119 225.554C42.1964 289.397 87.8799 334.161 122.339 360.476C142.385 375.808 163.932 389.067 186.651 400.051C192.909 403.063 199.683 398.234 204.649 394.927L257.655 359.887ZM34.7602 220.741C20.3869 177.724 13.8581 132.473 15.4854 87.1453C15.8453 75.5798 16.7617 63.9325 18.2097 52.4243C30.3947 54.0202 42.6704 54.824 54.9594 54.8308H55.0657C99.7886 55.4421 143.831 43.8396 182.454 21.2721V380.947C164.646 371.572 147.659 360.713 131.673 348.485C98.8589 323.496 55.4092 280.983 34.7682 220.766L34.7602 220.741Z"
        fill="#aaaaaa"
    />
    <!-- logo -->
    <image id="logo" x="780" y="375" width="170" height="170" href="" alt="logo" />
    <rect
        id="logo-hint"
        x="780"
        y="375"
        width="170"
        height="170"
        rx="3"
        ry="3"
        fill="none"
        stroke="red"
        stroke-width="1"
        stroke-dasharray="5 7"
        visibility="visible"
    />

    <!-- texts -->
    <foreignObject width="848" height="528" x="78" y="80">
        <xhtml:div class="align-center brand-info" xmlns="http://www.w3.org/1999/xhtml">
            <xhtml:p id="svg-tag1Line" class="text-32 "></xhtml:p>
            <xhtml:p id="svg-tag2Line" class="text-45 "></xhtml:p>
            
            <xhtml:p id="svg-contactLine1" class="text-32 "></xhtml:p>
            <xhtml:span id="svg-contactLine1Overflow" class="text-32 "></xhtml:span>
            <xhtml:p id="svg-contactLine2"></xhtml:p>
            <xhtml:span id="svg-contactLine2Overflow" class="text-32 "></xhtml:span>
            <xhtml:p id="svg-contactLine3" class="text-32 "></xhtml:p>
            <xhtml:span id="svg-contactLine3Overflow" class="text-32 "></xhtml:span>
        </xhtml:div>
    </foreignObject>
</svg>
